import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-730a8118"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "q-pa-lg ecran-container",
  style: {"font-family":"'Roboto', sans-serif"}
}
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Balanta")
const _hoisted_6 = {
  key: 0,
  style: {"font-family":"'Roboto', sans-serif","size":"1.5rem","font-weight":"bold"}
}
const _hoisted_7 = { class: "grid-container" }
const _hoisted_8 = { class: "grid-item" }
const _hoisted_9 = { class: "grid-item" }
const _hoisted_10 = { class: "grid-item" }
const _hoisted_11 = { class: "grid-item" }
const _hoisted_12 = {
  key: 2,
  class: "q-pa-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "paid",
                style: {"font-size":"2rem","position":"relative","top":"-3px"},
                color: "primary"
              }),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 1,
            flat: "",
            color: "blue",
            label: "Descarca Balanta format PDF",
            "no-caps": "",
            icon: "picture_as_pdf",
            loading: _ctx.downloadingFile,
            style: {"margin-left":"auto"},
            onClick: _ctx.downloadBalantaPdf
          }, null, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.existaBalanta)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", null, "Perioada 01.01.2022 - " + _toDisplayString(_ctx.currentDateAsString), 1),
          _createElementVNode("div", null, " Sold Initial " + _toDisplayString(_ctx.balantaInNav.SoldInit) + " Lei ", 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, "Total Credit " + _toDisplayString(_ctx.balantaInNav.SumCredit) + " Lei", 1),
            _createElementVNode("div", _hoisted_9, "Sold Credit " + _toDisplayString(_ctx.balantaInNav.SoldCredit) + " Lei", 1),
            _createElementVNode("div", _hoisted_10, "Total Debit " + _toDisplayString(_ctx.balantaInNav.SumDebit) + " Lei", 1),
            _createElementVNode("div", _hoisted_11, "Sold Debit " + _toDisplayString(_ctx.balantaInNav.SoldDebit) + " Lei", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$q.platform.is.mobile)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 1,
          flat: "",
          color: "blue",
          label: "Descarca Balanta format PDF",
          "no-caps": "",
          icon: "picture_as_pdf",
          loading: _ctx.downloadingFile,
          onClick: _ctx.downloadBalantaPdf
        }, null, 8, ["loading", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.existaBalanta)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_q_table, {
            grid: _ctx.$q.platform.is.mobile,
            class: "my-sticky-header-table",
            title: "",
            "rows-per-page-options": [0],
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
            rows: _ctx.balantaInNav.CustLedgerEntry,
            columns: _ctx.columns,
            "visible-columns": _ctx.visibleColumns,
            "row-key": "name",
            flat: "",
            bordered: ""
          }, {
            item: _withCtx((props) => [
              _createVNode(_component_q_card, {
                class: "my_card_3",
                style: _normalizeStyle({'background-color': props.row.isInvoiceOverdue ? '#DAF3F3':'white'})
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, { dense: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                        return (_openBlock(), _createBlock(_component_q_item, {
                          key: col.name
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(col.label), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_q_item_section, { side: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(col.value), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["style"])
            ]),
            _: 1
          }, 8, ["grid", "pagination", "rows", "columns", "visible-columns"])
        ]))
      : _createCommentVNode("", true)
  ]))
}